module.exports = __webpack_public_path__ + "img/logo_biotopia_row_white.7ff0d532.png";